export const shortDate = date => {
  const month = date.getUTCMonth() + 1
  const day = date.getUTCDate()
  const year = date.getUTCFullYear()
  return `${month}/${day}/${year}`
}

export const fullDate = date => {
  const day = shortDate(date)
  let hours = date.getUTCHours()
  const period = hours >= 12 ? 'pm' : 'am'
  if (hours === 0) {
    hours = 12
  }
  if (hours >= 12) {
    hours -= 12
  }
  const minutes = date.getUTCMinutes()
  return `${day}  ${hours}:${minutes === 0 ? '00' : minutes} ${period}`
}

/**
 * Use for hearing/issue dates.
 * Dates at exactly midnight UTC (T00:00:00.000Z) show date only — no court schedules
 * hearings at midnight. Any other time (including noon) shows the full date + time.
 */
export const smartDate = date => {
  const isMidnightUTC = date.getUTCHours() === 0 && date.getUTCMinutes() === 0
    && date.getUTCSeconds() === 0 && date.getUTCMilliseconds() === 0
  return isMidnightUTC ? shortDate(date) : fullDate(date)
}

const checkValue = (str, max) => {
  if (str.charAt(0) !== '0' || str == '00') {
    let num = parseInt(str)
    if (isNaN(num) || num <= 0 || num > max) num = 1
    str =
      num > parseInt(max.toString().charAt(0)) && num.toString().length == 1
        ? `0${num}`
        : num.toString()
  }
  return str
}

const checkYear = str => {
  const num = parseInt(str)
  if (str.length === 2 && str !== '19' && str !== '20' && num >= 19) {
    return `19${num}`
  }
  // attempt to manage years starting with 20
  // if (str.length === 2 && str !== '19' && str !== '20' && num <= 19) {
  //   return `20${num}`
  // }
  return str
}

export const userInputFormatDate = input => {
  if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3)
  const values = input.split('/').map(function(v) {
    return v.replace(/\D/g, '')
  })
  if (values[0]) values[0] = checkValue(values[0], 12)
  if (values[1]) values[1] = checkValue(values[1], 31)
  if (values[2]) values[2] = checkYear(values[2])
  const output = values.map(function(v, i) {
    return v.length == 2 && i < 2 ? `${v} / ` : v
  })
  return output.join('').substr(0, 14)
}

export const dateObjectFromString = input => {
  if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3)
  const values = input.split('/').map(function(v) {
    return v.replace(/\D/g, '')
  })

  const date = new Date();
  if (values[1]) {
    const day = checkValue(values[1], 31)
    date.setDate(Number(day))
  }
  if (values[0]) {
    const month = checkValue(values[0], 12) - 1
    date.setMonth(month)
  }
  if (values[2]) {
    const year = checkYear(values[2])
    date.setYear(Number(year))
  }

  return date
}

export const convertToDays = (value, unit) => {
  const unitsToDays = {
    days: 1,
    weeks: 7,
    months: 30,
  }
  return value * (unitsToDays[unit.toLowerCase()] || 1)
}
